export default __webpack_public_path__ + "static/media/STECRV.1a9b1f3a.png";